import { styled, Theme } from '@mui/material';
import { ChipSize, ChipStatus } from '.';
import { colors } from './../../utils/palette';

export const getStyleByStatus = (status: ChipStatus | undefined, theme: Theme) => {
  switch (status) {
    case 'success':
      return {
        color: theme.palette.success.dark,
        backgroundColor: colors.chip.successBackground,
      };
    case 'warning':
      return {
        color: theme.palette.warning.dark,
        backgroundColor: colors.chip.warningBackground,
      };
    case 'error':
      return {
        color: theme.palette.error.dark,
        backgroundColor: colors.chip.errorBackground,
      };
    case 'disabled':
      return {
        color: theme.palette.text.secondary,
        backgroundColor: colors.lightSecondary,
      };
    case 'unknown':
      return {
        color: colors.textSecondary,
        backgroundColor: colors.chip.unknownBackground,
      };
    default:
      return {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.common.white,
        border: '1px solid #D1D5DB',
      };
  }
};

export const getStyleBySize = (size: ChipSize, theme: Theme) => {
  switch (size) {
    case 'tiny':
      return {
        fontSize: 12,
        fontWeight: '300',
        lineHeight: '12px',
        letterSpacing: 0.15,
      };
    case 'small':
      return {
        padding: `0 ${theme.spacing(1)}`,
        fontWeight: 600,
        lineHeight: 2,
        fontSize: 10,
      };

    case 'large':
      return {
        padding: `${theme.spacing(1)} ${theme.spacing(4)}`,
        fontWeight: 600,
        lineHeight: 1.5,
        fontSize: 16,
      };
    case 'medium':
    default:
      return {
        padding: `0 ${theme.spacing(1)}`,
        fontWeight: 600,
        lineHeight: 2,
        fontSize: 12,
      };
  }
};

export const StyledChip = styled('span')<{
  status: ChipStatus | undefined;
  size: ChipSize;
  lenght: number;
}>(({ theme, status, size, lenght }) => ({
  display: 'inline-flex',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  minWidth: lenght === 1 ? '0px' : '20px',
  alignItems: 'center',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  justifyContent: 'center',
  width: lenght === 1 ? '20px' : 'unknown',
  height: lenght === 1 ? '20px' : 'unknown',
  padding: lenght === 1 ? '0px' : '2px 8px',
  borderRadius: size !== 'tiny' ? (size === 'large' ? 8 : 4) : lenght === 1 ? '50%' : 8,
  textTransform: size === 'large' ? 'capitalize' : size === 'tiny' ? 'inherit' : 'uppercase',
  ...getStyleByStatus(status, theme),
  ...getStyleBySize(size, theme),
}));

export const StyledStatusChip = styled('span')<{
  status: ChipStatus | undefined;
  size: ChipSize;
}>(({ theme, size }) => ({
  display: 'inline-flex',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  minWidth: '20px',
  alignItems: 'center',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  justifyContent: 'center',
  border: '1px solid #D1D5DB',
  textTransform: 'uppercase',
  ...getStyleBySize(size, theme),
}));
export const StyledStatusChipProgress = styled('span')<{
  status: ChipStatus | undefined;
  size: ChipSize;
  progress: number; // Stato del progresso
  backgroundColor: string; // Colore dinamico
}>(({ theme, size, progress, backgroundColor }) => ({
  display: 'inline-flex',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  minWidth: '20px',
  alignItems: 'center',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  justifyContent: 'center',
  border: '1px solid #D1D5DB',
  textTransform: 'uppercase',
  position: 'relative',
  overflow: 'hidden',
  ...getStyleBySize(size, theme),
  background: `linear-gradient(to right, ${backgroundColor} ${progress}%, white ${progress}%)`,
  transition: 'background 0.1s linear', // Transizione fluida
  color: 'white',
  width: 93,
}));

export const StyledDivForRoundIndicator = styled('div')<{
  status: ChipStatus | undefined;
}>(({ theme, status }) => ({
  borderRadius: '50%',
  height: 12,
  width: 12,
  marginRight: 8,
  backgroundColor: getStyleByStatus(status, theme).backgroundColor,
}));
